import { Box, Avatar } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UserProfileHeader = ({ userData }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleChatClick = () => {
    navigate('/chat');
  };

  // ✅ Default avatar fallback (local asset ya placeholder URL)
  const fallbackAvatar = '/assets/images/admin-panel/avatar-placeholder.svg';
  const profileSrc =
    userData?.profilePicture && userData.profilePicture.trim() !== ''
      ? userData.profilePicture
      : fallbackAvatar;

  return (
    <div className="user-profile-header gap-5">
      {/* Profile Image Wrapper */}
      <Box
        sx={{
          position: 'relative',
          minWidth: '150px',
          maxWidth: '150px',
          height: '150px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '2px solid var(--neutral-200)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'var(--neutral-100)',
        }}
      >
        {/* Avatar shown until image loads */}
        {!isImageLoaded && (
          <Avatar
            src={fallbackAvatar}
            alt="Avatar Placeholder"
            sx={{
              width: '100%',
              height: '100%',
              fontSize: '3rem',
              bgcolor: 'var(--neutral-200)',
            }}
          >
            {(userData?.firstName ?? userData?.userName)?.[0]?.toUpperCase() || 'U'}
          </Avatar>
        )}

        {/* Real profile image */}
        <Box
          component="img"
          src={profileSrc}
          alt="Profile"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
            display: isImageLoaded ? 'block' : 'none',
          }}
          onLoad={() => setIsImageLoaded(true)} // ✅ Image load hone par switch
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fallbackAvatar;
            setIsImageLoaded(true);
          }}
        />
      </Box>

      {/* User Details */}
      <div className="user-profile-details">
        <div className="userheddtal">
          <h2 className='text-capitalize'>
            {(userData?.firstName ?? userData?.userName)}, {userData?.age}
            {userData?.isOnline && <span className="user-online-status"></span>}
          </h2>
          <p className="user-location mb-0 mt-0">
            {[userData.city, userData.state, userData.country].filter(Boolean).join(", ")}
          </p>
        </div>

        <div className="usersbhdtl">
          <p className="user-description mb-0">{userData?.myHeading}</p>
        </div>

        {/* User Info Cards */}
        <div className="user-info-cards">
          {userData?.infoCards?.map((info, index) => (
            <div key={index} className="user-info-item">
              <span className="d-block">
                <img src={info.icon} className="img-fluid" alt={info.label} />
              </span>
              {info.value}
              <span className="font-12 font-m fw-normal color7b">
                {info.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserProfileHeader;
